import React, { useState } from "react";

//https://rixterdev.atlassian.net/plugins/servlet/ac/se.rixter.jira.restful.integrator.restful_integrator/ihub-integrations?s=se.rixter.jira.restful.integrator.restful_integrator__ihub-integrations/integration/9fea1db3-cff7-402c-84cd-2a562eb36f06
//should return https://rixterdev.atlassian.net/plugins/servlet/ac/se.rixter.jira.restful.integrator.restful_integrator/ihub-integrations

export const extractAppUrl = (url) => {
    const app = "plugins/servlet/ac/se.rixter.jira.restful.integrator.restful_integrator/ihub-integrations";
    const splittedUrl = url.split(app)
    //console.log("urlApp",splittedUrl)

    if(!splittedUrl){
      return undefined
    }
    return splittedUrl[0]+app;   
};
export const extractNavPath = (url) => {
    const app = "plugins/servlet/ac/se.rixter.jira.restful.integrator.restful_integrator/ihub-integrations";
    
    if (typeof url !== 'string' || !url.includes(app)) {
        return undefined; // Return early if the URL is invalid or doesn't contain the app path
    }

    const splittedUrl = url.split(app);

    if (splittedUrl.length <= 1) {
        return undefined; // Ensure there is a valid path after splitting
    }

    const result = splittedUrl[1].replace("?s=se.rixter.jira.restful.integrator.restful_integrator__ihub-integrations", "");

    return result ? result : undefined; // Return undefined if result is an empty string
};
